const SHARED_EXCLUDING_FIELDS = ['heading', 'lead', 'body'];

const SEO_EXCLUDING_FIELDS = [
  'alternate_ru',
  'alternate_en',
  'alternate_de',
  'alternate',
  'seo',
  'title',
  'description',
  'seoTitle',
  'seoDescription',
  'ogImage',
];

export const EXPERT_SITEMAP_EXCLUDING_FIELDS = [
  'name',
  'gender',
  'photo',
  'bigPhoto',
  'textAbout',
  'alternate',
  'availableOn',
  'education',
  'workExperience',
  'eventsOrganisation',
  'eventsParticipation',
  'publications',
  'realEstateGuidesSubheading',
  'realEstateGuides',
  'phoneNumber',
  'quoraLink',
  'redditLink',
  'facebookLink',
  'linkedinLink',
  'linksForSEO',
  'linkedinLink',
  ...SEO_EXCLUDING_FIELDS,
  ...SHARED_EXCLUDING_FIELDS,
].join(',');

export const PODCAST_SITEMAP_EXCLUDING_FIELDS = [
  'shortDescription',
  'fullDescription',
  'length',
  'episodeNumber',
  'iframeSrc',
  'articleLink',
  'expert',
  'appleLink',
  'googleLink',
  'spotifyLink',
  'youtubeLink',
  'sourceLink',
  'lengthSeo',
  ...SEO_EXCLUDING_FIELDS,
  ...SHARED_EXCLUDING_FIELDS,
].join(',');

export const ARTICLE_SITEMAP_EXCLUDING_FIELDS = [
  ...SHARED_EXCLUDING_FIELDS,
  ...SEO_EXCLUDING_FIELDS,
  'investmentProgram',
  'programPage',
  'author',
  'cardQuote',
  'oldSlug',
  'readMore',
  'blogLevel',
  'readMoreTitle',
  'statusService',
  'authorDescription',
  'faq',
  'audio',
  'legacySlugEn',
  'legacySlugRu',
  'postPriority',
  'coverImageAlt',
  'connectedExpert',
  'customerCountry',
  'withoutLanguage',
  'postUpdatedPersent',
  'previewDescription',
  'description',
  'oneLanguage',
  'pagePurpose',
  'currency',
  'customer',
  'imageNew',
  'ogImage',
  'budget',
  'expert',
  'image',
  'year',
  'noCustomer',
  'pageAuthor',
].join(',');

export const CAREERS_SITEMAP_EXCLUDING_FIELDS = [
  'isRemote',
  'country',
  'city',
  ...SEO_EXCLUDING_FIELDS,
  ...SHARED_EXCLUDING_FIELDS,
].join(',');

export const CBI_GUIDE_SITEMAP_EXCLUDING_FIELDS = [
  'briefHeading',
  'facts',
  'faq',
  'expert',
  'updateDate',
  'previewHeading',
  'previewDescription',
  'previewLink',
  ...SEO_EXCLUDING_FIELDS,
  ...SHARED_EXCLUDING_FIELDS,
].join(',');

export const EVENT_AND_WORKSHOP_SITEMAP_EXCLUDING_FIELDS = [
  'performers',
  'endDate',
  'startDate',
  'date',
  'address',
  'city',
  'country',
  'imageGallery',
  'previewHeading',
  'previewDescription',
  'image',
  'attendanceMode',
  'type',
  'status',
  ...SEO_EXCLUDING_FIELDS,
  ...SHARED_EXCLUDING_FIELDS,
].join(',');

export const FACTSHEET_AND_PRICE_SITEMAP_EXCLUDING_FIELDS = [
  'formId',
  'availableOn',
  'imageLegacy',
  'image',
  'buttonBottomText',
  'recieveList',
  'faq',
  'costString',
  'costLabel',
  ...SEO_EXCLUDING_FIELDS,
  ...SHARED_EXCLUDING_FIELDS,
].join(',');

export const PAGE_SITEMAP_EXCLUDING_FIELDS = [
  'schemas',
  'image',
  'imaegNew',
  'faq',
  ...SHARED_EXCLUDING_FIELDS,
  ...SEO_EXCLUDING_FIELDS,
].join(',');

export const PROGRAM_SITEMAP_EXCLUDING_FIELDS = [
  'investmentProgram',
  'country',
  'pageStatus',
  'tableOfContents',
  'schemaExtraFieldsAsJson',
  ...SEO_EXCLUDING_FIELDS,
  ...SHARED_EXCLUDING_FIELDS,
].join(',');
